import { rest } from 'utils';
import { getConfig } from 'utils/config';

export default {
  login: ({ email, password }) => rest.get({
    url: 'contracts?depth=10',
    headers: {
      Authorization: `Basic ${btoa(`${email}:${password}`)}`,
    },
    secure: false,
  }),

  getJwtToken: ({ token }) => {
    const configs = getConfig() || {};

    return rest.get({
      baseUrl: `${configs.apiAuthUrl}/tokens/generate?client=DCD`,
      headers: token ? {
        Authorization: `Basic ${token}`,
      } : {},
      secure: !token,
    });
  },

  checkPassword: ({ email, password }) => rest.get({
    url: 'contracts?depth=10',
    headers: {
      Authorization: `Basic ${btoa(`${email}:${password}`)}`,
      noAuth: true,
    },
    secure: false,
  }),
};
